export default {
  'checkIssue.add': 'Add Check Issue(s)/Void(s)',
  'checkIssue.checkIssue': 'check issue',
  'checkIssue.checkIssues': 'check issues',
  'checkIssue.checkIssuesAndVoids': '<%= issues %> and <%= voids %>',
  'checkIssue.deleted': 'deleted',
  'checkIssue.deleteIssuesVoids': 'Delete check issues/voids',
  'checkIssue.failedImports': 'Failed Imports',
  'checkIssue.failedImports.screnReaderHeader': 'View Failed Imports',
  'checkIssue.importFile': 'Import Issue File',
  'checkIssue.importNumber': 'Import Number',
  'checkIssue.issuesNumber': 'Issues Number',
  'checkIssue.issueVoided': 'Issue Voided',
  'checkIssue.issuePaid': 'Issue Paid',
  'checkIssue.ofIssues': '#Of Issues',
  'checkIssue.ofVoids': '#Of Voids',
  'checkIssue.totalAmountIssuedChecks': 'Total Amount Of Issued Checks',
  'checkIssue.totalAmountVoids': 'Total Amount Of Voids',
  'checkIssue.void': 'void',
  'checkIssue.voidDate': 'Void Date',
  'checkIssue.voids': 'voids',
  'checkIssue.voidsNumber': 'Voids Number',
  'checkIssue.outstanding': 'Outstanding',
  'checkIssue.paidDate': 'Paid Date',
  'checkIssue.entered': 'Entered',
  'checkIssue.reconciled': 'Reconciled',
  'checkIssue.stale': 'Stale',
  'checkIssue.allItems': 'All Items',

  'checkIssue.delete.message': 'Are you sure you want to delete',
  'checkIssue.delete.success': 'The file has been deleted successfully',
  'checkIssue.delete.title': 'Delete file',

  'checkIssue.message.areYouSure':
    'Selected items will be deleted and this action cannot be undone. Do you wish to proceed?',
  'checkIssue.message.notEligibleForDeletion':
    'Some items are not eligible for deletion. Please modify selection.',

  'checkIssue.tab.checkIssuesVoids': 'Check Issues/Voids',
  'checkIssue.tab.checkIssueStatus': 'Check Issue Status',
  'checkIssue.tab.importIssueFiles': 'Import Issue Files',
  'checkIssue.tab.importMapping': 'Import Mapping'
};
